import  moment  from 'moment';
import React, { Component } from "react";
import { connect } from "react-redux";

class SearchResultNamQHC extends Component {
  constructor(props) {
    super(props);

    this.state = {
      activeTab: "DuAn",
      data: {},
    };

    this.listDuAnTitle = [
      "Năm quy hoạch",
      "Ngày ra quyết định",
      "Nơi ra quyết định",
      "Quyết định số",
    ];

    this.listDuAnValue = [
      "NamQH",
      "NgayRaQD",
      "NoiRaQD",
      "NamQH",
      "QuyetDinh",
    ];
  }






  render() {
    return (
      <>
        {this.props.data && (
          <div className="search-result-lop-du-lieu">
            <div className="search-500-header">
              Thông tin dự án quy hoạch chung 1/10000
              <i className="fas fa-times icon-close" onClick={this.props.close}></i>
            </div>

            <div className="search-500-body">
              {this.listDuAnTitle.map((e, i) => (
                <div style={{ display: "flex" }} key={i}>
                  <div className="col-left-10000 search-500-text">
                    {e}:
                  </div>

                  <div className="col-right-10000 search-500-text-gray">
                    {this.props.data[`${this.listDuAnValue[i]}`]
                      ? this.props.data[`${this.listDuAnValue[i]}`] !== "Null"
                        ? i === 1
                          ? moment(new Date(this.props.data[`${this.listDuAnValue[i]}`])).utc(0).format("DD/MM/YYYY") 
                          : this.props.data[`${this.listDuAnValue[i]}`]
                        : "-"
                      : "-"}
                  </div>
                </div>
              ))}

              {/* {this.props.file && (
                <div style={{ display: "flex" }}>
                  <div className="col-left-10000 search-500-text">
                    File đính kèm:
                  </div>
                  <div>
                    {this.props.file.map((e, i) => (
                      <div
                        className="col-right-10000 search-500-text"
                        style={{
                          overflow: "hidden",
                          textOverflow: "ellipsis",
                          maxWidth: "125px",
                        }}
                      >
                        <a href={e.Duongdanfiledinhkem}>{e.Tenfiledinhkem}</a>
                      </div>
                    ))}
                  </div>
                </div>
              )} */}
            </div>
          </div>
        )}
      </>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    isEnableLayer: state.map.isEnableLayer,
  };
};

const mapDispatchToProps = {};

export default connect(mapStateToProps, mapDispatchToProps)(SearchResultNamQHC);
